<template>
    <tbody>
        <tr>
            <td class="col-xs-2 text-center" style="background-color: #eaeaea;">
                <input type="checkbox" :checked="isSelected" @change.prevent="select">
            </td>

            <td colspan="4" style="background-color: #eaeaea;" @click="isVisible = !isVisible">
                <strong>
                    HG{{ order.id }} ({{ order.company.name }})
                </strong>

                <div class="btn-group list-actions pull-right">
                    <button type="button" class="btn btn-sm">
                        <i class="fa" :class="{'fa-angle-up': isVisible, 'fa-angle-down': !isVisible}"></i>
                    </button>
                </div>
            </td>
        </tr>

        <template v-if="isVisible">
            <tr
                    is="ad"
                    v-for="ad in order.ads"
                    :key="ad.type + '-' + ad.id"
                    :ad="ad"
                    :month="month"
                    :disable-invoiced-ads="disableInvoicedAds"
                    :disable-unpublished-ads="disableUnpublishedAds"
                    :selected-buyables="selectedBuyables"
                    @add-ad="$emit('add-ad', $event)"
                    @remove-ad="$emit('remove-ad', $event)"
            ></tr>
        </template>
    </tbody>
</template>

<script>
    import Ad from '@/components/BuyableSelect/Ad'

    export default {
        components: {Ad},

        props: {
            'order': {}, 
            'month': {}, 

            disableInvoicedAds: {
                default: true
            },

            disableUnpublishedAds: {
                default: true
            },

            'selected': {},
            'selectedBuyables': {}
        },

        data() {
            return {
                isVisible: false
            }
        },

        computed: {
            isSelected() {
                return this.selected.findIndex(existing => existing === this.order) > -1
            }
        },

        methods: {
            select() {
                if (this.isSelected) {
                    return this.$emit('remove-order', this.order)
                }

                return this.$emit('add-order', this.order)
            }
        }
    }
</script>
